import { useState, useEffect } from 'react'
import { GetPlanOrganizationOrganizations } from '../services/AnnualPlanService'
import { type PlanOrganizationOrganizations } from '../models/PlanOrganizationOrganizations'

interface UseRcnIsdsType {
  planOrganizationOrgs: PlanOrganizationOrganizations | null
  isLoading: boolean
  errors?: string[]
}
export const usePlanOrganizationOrgs = (planOrgId: number): UseRcnIsdsType => {
  const [planOrganizationOrgs, setPlanOrganizationOrgs] = useState<PlanOrganizationOrganizations | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [errors, setErrors] = useState<string[]>()

  useEffect(() => {
    const getPlanOrganizationOrgs = async (): Promise<void> => {
      setErrors(undefined)
      setIsLoading(true)
      const { success, errors, response: planOrgOrgs } = await GetPlanOrganizationOrganizations(planOrgId)
      if (!success) {
        setErrors(errors)
        errors?.forEach((error) => { console.error(error) })
      }
      setPlanOrganizationOrgs(planOrgOrgs)
      setIsLoading(false)
    }

    void getPlanOrganizationOrgs()
  }, [planOrgId])

  return { planOrganizationOrgs, isLoading, errors }
}
